import api from './axios';

// ── Operadoras e modelos ─────────────────────────────────────────────────────
export const listarOperadoras = () => api.get('/operadoras/');

/** Como esta operadora fecha o ciclo glosa → recurso → pagamento.
 *  `null` em qualquer campo volta ao estado honesto de "não verificado". */
export const definirPolitica = (idOperadora, corpo) =>
  api.patch(`/operadoras/${idOperadora}/politica`, corpo);
export const listarModelos = (idOperadora) => api.get(`/operadoras/${idOperadora}/modelos`);

// ── Arquivos de recebimento ──────────────────────────────────────────────────
export const listarArquivos = () => api.get('/arquivos/');
export const detalheArquivo = (id) => api.get(`/arquivos/${id}`);
export const confirmarArquivo = (id) => api.post(`/arquivos/${id}/confirmar`);
// Revisão de vários de uma vez. A rota é literal e vem DECLARADA ANTES das
// parametrizadas no backend, senão `/{id_arquivo}` a engoliria.
export const confirmarArquivos = (ids) =>
  api.post('/arquivos/confirmar-varios', { ids });
export const conciliarArquivo = (id) => api.post(`/arquivos/${id}/conciliar`);

/* Apagar um recebimento desfaz uma conciliacao inteira, entao a tela pergunta
   antes — e a previa diz, em numeros, o que sai e o que fica. So ADMIN. */
export const previaExclusaoArquivo = (id) =>
  api.get(`/arquivos/${id}/previa-exclusao`);
export const excluirArquivo = (id, { limparResolucoes = false } = {}) =>
  api.delete(`/arquivos/${id}`, {
    params: { limpar_resolucoes: limparResolucoes },
  });

export function enviarArquivo({ idOperadora, competencia, arquivo, onProgress }) {
  const form = new FormData();
  form.append('id_operadora', idOperadora);
  if (competencia) form.append('competencia', competencia);
  form.append('arquivo', arquivo);

  return api.post('/arquivos/', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    // Demonstrativos grandes levam tempo: a extração roda no request.
    timeout: 300000,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
}

// ── Dashboard ────────────────────────────────────────────────────────────────
export const resumoDashboard = () => api.get('/dashboard/resumo');
export const visaoArquivos = () => api.get('/dashboard/arquivos');
export const visaoProtocolos = (params) => api.get('/dashboard/protocolos', { params });
export const detalheProtocolo = (protocolo, params) =>
  api.get(`/dashboard/protocolos/${encodeURIComponent(protocolo)}`, { params });
export const visaoBaixas = () => api.get('/dashboard/baixas');
export const visaoAgenda = (params) => api.get('/dashboard/agenda', { params });
export const filtrosDaAgenda = () => api.get('/dashboard/agenda/filtros');
export const visaoGlosas = (params) => api.get('/dashboard/glosas', { params });
/* O nivel abaixo de qualquer agrupamento: o item glosado, um a um. */
export const itensGlosados = (params) =>
  api.get('/dashboard/glosas/itens', { params });

/* A mesa de trabalho do auditor: a guia glosada com TODOS os seus itens,
   pago e glosado lado a lado. E a proporcao, nao o valor isolado, que diz
   se vale recorrer. */
export const auditoriaGlosa = (params) =>
  api.get('/dashboard/glosas/auditoria', { params });
/* Em cascata: as opcoes dependem do que os outros filtros ja selecionaram. */
export const filtrosDeGlosa = (params) =>
  api.get('/dashboard/glosas/filtros', { params });
export const itensDaGuia = (guia) =>
  api.get(`/dashboard/guias/${encodeURIComponent(guia)}/itens`);

/**
 * Baixa de um protocolo em Excel ou PDF.
 *
 * `responseType: 'blob'` e obrigatorio: sem ele o axios trata o binario como
 * texto e o arquivo baixado chega corrompido — sintoma classico de planilha
 * que "o Excel nao abre".
 */
export const exportarProtocolo = (protocolo, { formato, idArquivo }) =>
  api.get(`/dashboard/protocolos/${encodeURIComponent(protocolo)}/exportar`, {
    params: { formato, id_arquivo: idArquivo },
    responseType: 'blob',
    // 600 guias em PDF levam alguns segundos para renderizar.
    timeout: 120000,
  });

/* ── Envio em lote ───────────────────────────────────────────────────────── */
export function enviarLote({
  idOperadora,
  arquivos,
  competencias,
  sincronizarBioslab = true,
  onProgress,
}) {
  const form = new FormData();
  form.append('id_operadora', idOperadora);
  form.append('sincronizar_bioslab', sincronizarBioslab ? 'true' : 'false');
  // `arquivos` e `competencias` andam juntos, posicao a posicao: o servidor
  // casa os dois pelo indice, entao a ordem de append importa.
  arquivos.forEach((a) => form.append('arquivos', a));
  competencias.forEach((c) => form.append('competencias', c || ''));
  return api.post('/arquivos/lote', form, {
    // Oito PDFs de ate 40 MB levam tempo so para subir; o processamento em si
    // acontece depois, na fila, e nao conta neste timeout.
    timeout: 600000,
    onUploadProgress: (e) =>
      onProgress && e.total && onProgress(Math.round((e.loaded * 100) / e.total)),
  });
}

export const estadoLote = (id) => api.get(`/arquivos/lote/${id}`);
export const listarLotes = () => api.get('/arquivos/lotes');
export const retomarLote = (id) => api.post(`/arquivos/lote/${id}/retomar`);
export const visaoPendencias = (params) => api.get('/dashboard/pendencias', { params });
export const visaoDivergencias = (params) => api.get('/dashboard/divergencias', { params });

// ── Usuários ─────────────────────────────────────────────────────────────────
export const listarUsuarios = () => api.get('/usuarios/');
export const perfisDisponiveis = () => api.get('/usuarios/perfis');
export const criarUsuario = (dados) => api.post('/usuarios/', dados);
export const atualizarUsuario = (id, dados) => api.patch(`/usuarios/${id}`, dados);
export const ativarUsuario = (id) => api.post(`/usuarios/${id}/ativar`);
export const inativarUsuario = (id) => api.post(`/usuarios/${id}/inativar`);
export const resetarSenhaUsuario = (id, nova_senha) =>
  api.post(`/usuarios/${id}/resetar-senha`, { nova_senha });
export const alterarPropriaSenha = (senha_atual, nova_senha) =>
  api.post('/usuarios/eu/senha', { senha_atual, nova_senha });

// ── Auditoria (somente admin) ────────────────────────────────────────────────
export const listarAuditoria = (params) => api.get('/auditoria/', { params });
export const filtrosAuditoria = () => api.get('/auditoria/filtros');
export const resumoAuditoria = () => api.get('/auditoria/resumo');

/* ── Cadastro assistido de modelo de operadora ───────────────────────────── */
export const listarTodosModelos = (status) =>
  api.get('/modelos/', { params: status ? { status } : {} });
export const detalharModelo = (id) => api.get(`/modelos/${id}`);
export const iaDisponivel = () => api.get('/modelos/ia/disponivel');
export const catalogoDeCampos = () => api.get('/modelos/catalogo/campos');
export const coberturaDeModelos = () => api.get('/modelos/cobertura');

/** O que esta operadora aceita — mostrado na tela de lancamento. */
export const orientacaoDeEnvio = (idOperadora) =>
  api.get(`/operadoras/${idOperadora}/envio`);

/**
 * Sobe o arquivo-exemplo e recebe a especificação inferida, já submetida às
 * conferências aritméticas. Só a ESTRUTURA do documento vai para a IA.
 */
export function inferirModelo({ arquivo, nomeOperadora, nomeModelo, observacao, onProgress }) {
  const form = new FormData();
  form.append('arquivo', arquivo);
  form.append('nome_operadora', nomeOperadora);
  if (nomeModelo) form.append('nome_modelo', nomeModelo);
  if (observacao) form.append('observacao', observacao);
  return api.post('/modelos/inferir', form, {
    // A inferência envolve uma chamada externa: o padrão do axios é curto demais.
    timeout: 300000,
    onUploadProgress: (e) =>
      onProgress && e.total && onProgress(Math.round((e.loaded * 100) / e.total)),
  });
}

/**
 * Cadastra de uma vez os varios arquivos que uma operadora manda.
 *
 * E assim que a Unimed entra: demonstrativo de pagamento e extrato de glosa
 * juntos. O sistema mapeia cada um e classifica a relacao entre eles.
 */
export function inferirConjunto({ arquivos, nomeOperadora, nomeConjunto, observacao, onProgress }) {
  const form = new FormData();
  arquivos.forEach((a) => form.append('arquivos', a));
  form.append('nome_operadora', nomeOperadora);
  if (nomeConjunto) form.append('nome_conjunto', nomeConjunto);
  if (observacao) form.append('observacao', observacao);
  return api.post('/modelos/inferir-conjunto', form, {
    // Uma chamada a IA POR ARQUIVO, cada uma ate 180 s.
    timeout: 900000,
    onUploadProgress: (e) =>
      onProgress && e.total && onProgress(Math.round((e.loaded * 100) / e.total)),
  });
}

export function ajustarRelacaoConjunto(idConjunto, relacao) {
  const form = new FormData();
  form.append('relacao', relacao);
  return api.post(`/modelos/conjuntos/${idConjunto}/relacao`, form);
}

export function ajustarPapelModelo(idModelo, papel) {
  const form = new FormData();
  form.append('papel', papel);
  return api.post(`/modelos/${idModelo}/papel`, form);
}

/*
 * As tres acoes abaixo mandam JSON, nao `FormData`, e a diferenca nao e
 * estetica: um `FormData` vazio — o caso normal, porque a observacao e
 * opcional — chega ao servidor como multipart sem nenhuma parte, e o Starlette
 * responde **400 "error parsing the body"** antes de a rota rodar. O erro nao
 * passa pela nossa camada, entao a tela mostrava "Bad Request" sem explicacao.
 * Nenhuma delas carrega arquivo; so o cadastro, logo acima, precisa de
 * multipart de fato.
 */
export function retentarInferencia(id, observacao) {
  return api.post(`/modelos/${id}/retentar`, { observacao }, { timeout: 300000 });
}

export function submeterModelo(id, observacao) {
  return api.post(`/modelos/${id}/submeter`, { observacao });
}

/**
 * Manda ao admin TODOS os modelos do conjunto, de uma vez.
 *
 * Um conjunto e uma decisao unica. Submeter um a um convida ao meio-caminho:
 * o demonstrativo aprovado e o extrato de glosa esquecido em rascunho, com a
 * operadora funcionando pela metade e recusando o segundo arquivo sem
 * ninguem entender por que.
 */
export function submeterConjunto(idConjunto, observacao) {
  return api.post(`/modelos/conjuntos/${idConjunto}/submeter`, { observacao });
}

export function aprovarModelo(id, { aprovarSemValidacao = false, observacao } = {}) {
  return api.post(`/modelos/${id}/aprovar-guardado`, {
    aprovar_sem_validacao: aprovarSemValidacao,
    observacao,
  });
}

/* ── Ações do admin sobre um modelo ──────────────────────────────────────── */
export const inativarModelo = (id, reativar = false) =>
  api.post(`/modelos/${id}/inativar`, null, { params: { reativar } });

export const excluirModelo = (id) => api.delete(`/modelos/${id}`);

export function rejeitarModelo(id, motivo) {
  const form = new FormData();
  form.append('motivo', motivo);
  return api.post(`/modelos/${id}/rejeitar`, form);
}

/* ── Pendências: reprocessar e resolver à mão ────────────────────────────── */
export const reprocessarPendencias = (idsPendencia) =>
  // A consulta ao Bioslab pode demorar: o padrão do axios é curto demais.
  api.post('/pendencias/reprocessar', { ids_pendencia: idsPendencia }, { timeout: 180000 });

/**
 * Consulta o Bioslab pelo SEGUNDO numero da guia (a `Guia Prest.`).
 *
 * Nao grava nada: devolve o que foi encontrado para a tela pre-preencher o
 * formulario de resolucao manual, que continua exigindo confirmacao humana.
 */
export const consultarGuiaPrestador = (idPendencia) =>
  api.post(`/pendencias/${idPendencia}/consultar-guia-prestador`, null, {
    timeout: 60000,
  });

export const resolverPendenciaManual = (idPendencia, dados) =>
  api.post(`/pendencias/${idPendencia}/resolver-manual`, dados);

/* ── Auditoria das integrações (somente admin) ───────────────────────────── */
export const listarIntegracoes = (params) =>
  api.get('/auditoria/integracoes', { params });
export const detalheIntegracao = (id) => api.get(`/auditoria/integracoes/${id}`);

/* ── Visões estratégicas do dashboard ────────────────────────────────────── */
export const visaoAtendimentoXCompetencia = () =>
  api.get('/dashboard/atendimento-x-competencia');
export const visaoOperadoras = () => api.get('/dashboard/operadoras');
export const indicadoresGestao = () => api.get('/dashboard/indicadores');
export const evolucaoMensal = () => api.get('/dashboard/evolucao');

/* ── Saldo por protocolo: cobrado − recebido − glosado ───────────────────── */
export const visaoSaldo = (params) => api.get('/saldo/', { params });
export const filtrosDeSaldo = (params) => api.get('/saldo/filtros', { params });

/** As apurações já feitas. O valor corrente não diz se a cobrança funciona —
 *  a sequência diz, e ela não dá para reconstruir depois. */
export const historicoDeSaldo = (protocolo) =>
  api.get('/saldo/historico', { params: protocolo ? { protocolo } : undefined });

/**
 * Busca no Bioslab o total cobrado dos protocolos JÁ CONHECIDOS.
 *
 * Nunca se pergunta ao Bioslab quais protocolos existem — só se consulta os
 * que apareceram em algum arquivo lançado. O tempo é longo de propósito: são
 * lotes contra a produção de terceiro.
 */
export const sincronizarSaldo = () =>
  api.post('/saldo/sincronizar', null, { timeout: 180000 });

/** Apaga o total cobrado de protocolos que não têm mais arquivo lançado.
 *  Reconstituível: "Atualizar totais" traz de volta quando houver arquivo. */
export const limparSaldosOrfaos = () => api.post('/saldo/limpar-orfaos');

/* ── Por guia: o mesmo recorte da baixa, um nível abaixo ─────────────────── */

/** Paginada e ordenada NO SERVIDOR — são ~600 guias por arquivo, e a base
 *  cresce a cada competência. Ordenar só a página aberta mentiria. */
export const visaoPorGuia = (params) => api.get('/dashboard/guias', { params });

/** As opções de cada filtro, em cascata e cada um ignorando a si mesmo. */
export const filtrosPorGuia = (params) =>
  api.get('/dashboard/guias/filtros', { params });

/* ── Controles de manutenção (somente ADMIN) ─────────────────────────────── */

/** O que a limpeza apagaria, tabela a tabela. Não apaga nada. */
export const previaDaLimpeza = (preservarModelos) =>
  api.get('/controles/previa-limpeza', {
    params: { preservar_modelos: !!preservarModelos },
  });

/** Apaga tudo menos usuários e auditoria. Longo: são milhares de linhas. */
export const limparBase = (preservarModelos) =>
  api.post('/controles/limpar-base', null, {
    params: { preservar_modelos: !!preservarModelos },
    timeout: 120000,
  });

/** Quantos arquivos o disco guarda sem nenhuma tabela apontando. */
export const previaDeOrfaos = () => api.get('/controles/orfaos');

/** Apaga do disco o que perdeu o dono. Não toca em nenhuma linha de tabela. */
export const limparOrfaos = () =>
  api.post('/controles/limpar-orfaos', null, { timeout: 120000 });

/** O que os JSONs versionados contêm, e o que já está na base. */
export const resumoDasSeeds = () => api.get('/controles/seeds');

/** Carrega `modelos-operadora/` para o banco. Só mexe em modelo de mesmo nome. */
export const aplicarSeeds = () =>
  api.post('/controles/aplicar-seeds', null, { timeout: 120000 });

/* ── Títulos a lançar: as três contas e o estado do lançamento ───────────── */

/** Um título por linha, com recebido, glosado, retido e o que há para fazer. */
export const visaoTitulos = (params) => api.get('/lancamentos/', { params });

/** Opções de cada filtro, em cascata e cada um ignorando a si mesmo. */
export const filtrosDeTitulos = (params) =>
  api.get('/lancamentos/filtros', { params });

/** Contas, movimentos de retido e a linha do tempo de um protocolo. */
export const detalheDoTitulo = (protocolo) =>
  api.get(`/lancamentos/${encodeURIComponent(protocolo)}/detalhe`);

/** Marca que as TRÊS contas deste título foram lançadas no Nasajon. */
export const confirmarLancamento = (protocolo, corpo) =>
  api.post(`/lancamentos/${encodeURIComponent(protocolo)}/confirmar`, corpo || {});

/** Em lote. Um título que falhe não derruba os outros. */
export const confirmarVarios = (protocolos) =>
  api.post('/lancamentos/confirmar-varios', { protocolos }, { timeout: 120000 });

/** Retenção judicial — manual, é o único caminho. */
// A série mês a mês, os indicadores e a glosa por causa. Separada do
// detalhe: varre competências, recuperações e causas, e quem só vai lançar a
// baixa não precisa pagar por isso. A tela carrega as duas em paralelo.
// A ponte entre o que a operadora recusou e o que entra no titulo. Rota
// literal declarada ANTES de `/glosas/{...}` no backend.
export const ponteDaGlosa = () => api.get('/dashboard/glosas/ponte');

export const evolucaoDoTitulo = (protocolo) =>
  api.get(`/lancamentos/${encodeURIComponent(protocolo)}/evolucao`);

export const informarRetido = (protocolo, corpo) =>
  api.post(`/lancamentos/${encodeURIComponent(protocolo)}/retido`, corpo);

/** Corrige um retido com movimento de sinal trocado; o original permanece. */
export const estornarRetido = (idMovimento, justificativa) =>
  api.post(`/lancamentos/retido/${idMovimento}/estornar`, { justificativa });

/** O que um envio deixou para fazer no Nasajon — a costura entre lançar o
 *  arquivo e saber o passo seguinte. */
export const impactoDoEnvio = (params) =>
  api.get('/lancamentos/impacto', { params });

// ── Recuperação de glosa ────────────────────────────────────────────────────
// A glosa que voltou a ser paga depois de um recurso. O sistema só PROPÕE;
// quem decide é uma pessoa, com a evidência dos dois lados à vista.

/** Pares glosado-depois-pago aguardando decisão. Não aplica nada. */
export const candidatosRecuperacao = (params) =>
  api.get('/recuperacoes/candidatos', { params });

/** Abate uma glosa contra o pagamento que a desfez. */
export const confirmarRecuperacao = (corpo) =>
  api.post('/recuperacoes/confirmar', corpo);

/** Em lote. Uma que falhe não derruba as outras. */
export const confirmarRecuperacoes = (itens) =>
  api.post('/recuperacoes/confirmar-varios', { itens }, { timeout: 120000 });

/** Desfaz o vínculo sem apagar a evidência de que ele existiu. */
export const cancelarRecuperacao = (idRecuperacao, motivo) =>
  api.post(`/recuperacoes/${idRecuperacao}/cancelar`, { motivo });
